var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLeft = function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.24 4.449a1.18 1.18 0 0 0 0-1.698 1.25 1.25 0 0 0-1.737 0L5.34 10.727a1.77 1.77 0 0 0 0 2.546l8.163 7.976c.48.468 1.258.468 1.737 0a1.18 1.18 0 0 0 0-1.697L7.511 12z"
  })));
};
export default SvgIconArrowLeft;